import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b590982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-personal-create-wrapper" }
const _hoisted_2 = { class: "inline-text" }
const _hoisted_3 = { class: "block-personal-create__company-info" }

import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { NImage, NEllipsis } from 'naive-ui'
import ChangeAccountBtn from '@teams/common/components/changeAccountBtn'
import defaultAvatar from '@/assets/defaultAvatar.png'

interface IUser {
  userAvatar: string
  nickname: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'blockPersonalCreate',
  props: {
    user: null
  },
  emits: ['closeAll'],
  setup(__props: any, { emit }) {



const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.blockPersonalCreate.${key}`, ...params)
}

const i18n = reactive({
  beforeSuffix: computed(() => {
    return $tt('beforeSuffix')
  }),
  afterSuffix: computed(() => {
    return $tt('afterSuffix')
  })
})

const closeDialog = () => {
  emit('closeAll')
}

const changeClickBtn = () => {
  closeDialog()
}

return (_ctx: any,_cache: any) => {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NSpace = _resolveComponent("NSpace")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NEllipsis), {
      class: "block-personal-create__tips",
      style: {"max-width":"384px"},
      "line-clamp": 2,
      tooltip: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(i18n.beforeSuffix) + " ", 1),
            _createVNode(_unref(NImage), {
              width: "22",
              height: "22",
              src: __props.user.userAvatar,
              "fallback-src": _unref(defaultAvatar),
              class: "block-personal-create__img",
              "preview-disabled": ""
            }, null, 8, ["src", "fallback-src"]),
            _createVNode(_unref(NEllipsis), { style: {"max-width":"181px","font-weight":"500"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.user.nickname || '暂无昵称'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, _toDisplayString(i18n.afterSuffix), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_NSpace, {
      class: "block-personal-create__footer",
      size: 12,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NButton, {
          type: "default",
          size: "medium",
          onClick: closeDialog,
          style: { width: '80px' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($tt('cancelText')), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(ChangeAccountBtn), {
          btnText: $tt('okText'),
          type: "primary",
          isShowRectangle: false,
          scrollbarStyle: {
          maxHeight: '280px',
          marginTop: '4px'
        },
          itemStyle: { margin: '2px 4px' },
          popoverStyle: { width: '296px' },
          onChangeClickBtn: changeClickBtn
        }, null, 8, ["btnText"])
      ]),
      _: 1
    })
  ]))
}
}

})